import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {UserEditComponent} from "./users/user-edit/user-edit.component";
import {UsersComponent} from "./users/users.component";
import {LogsComponent} from "./logs/logs.component";
import {NetworksComponent} from "./networks/networks.component";
import {CompaniesComponent} from "./companies/companies.component";
import {SitesComponent} from "./sites/sites.component";
import {UnitsComponent} from "./units/units.component";
import {MeasuresComponent} from "./measures/measures.component";
import {NetworkEditComponent} from "./networks/network-edit/network-edit.component";
import {DeviceComponent} from "./device/device.component";
import {DeviceTypeComponent} from "./device-type/device-type.component";
import {DeviceTypeEditComponent} from "./device-type/device-type-edit/device-type-edit.component";
import {YmlEditorComponent} from "./yml/yml-editor/yml-editor.component";
import {YmlListComponent} from "./yml/yml-list/yml-list.component";
import {DeviceViewComponent} from "./device/device-view/device-view.component";
import {UnitEditComponent} from "./units/unit-edit/unit-edit.component";
import {MeasureEditComponent} from "./measures/measure-edit/measure-edit.component";
import {DeviceAttributeEditComponent} from "./device-attribute/device-attribute-edit/device-attribute-edit.component";
import {DeviceAttributeComponent} from "./device-attribute/device-attribute.component";
import {ModbusrtuComponent} from "./modbusrtu/modbusrtu.component";
import {ModbusrtuEditComponent} from "./modbusrtu/modbusrtu-edit/modbusrtu-edit.component";
import {AccessGuardService} from "./shared/access-guard.service";
import {InfluxComponent} from "./influx/influx.component";
import {UploaderComponent} from "./uploader/uploader.component";
import {SyncComponent} from "./sync/sync.component";
import {AxMpointSyncComponent} from "./sync/ax-mpoint-sync/ax-mpoint-sync.component";
import {AttributelookupComponent} from "./attributelookup/attributelookup.component";

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: HomeComponent,
      },

      {
        path: 'data',
        canActivate: [AccessGuardService],
        children: [
          {
            path: 'company',
            component: CompaniesComponent
          },
          {
            path: 'measure',
            children: [
              {
                path: '',
                component: MeasuresComponent
              },
              {
                path: ':id',
                component: MeasureEditComponent
              }
            ]
          },
          {
            path: 'modbusrtu',
            children: [
              {
                path: '',
                component: ModbusrtuComponent
              },
              {
                path: ':id',
                component: ModbusrtuEditComponent
              }
            ]
          },
          {
            path: 'site',
            component: SitesComponent
          },
          {
            path: 'unit',
            children: [
              {
                path: '',
                component: UnitsComponent
              },
              {
                path: ':id',
                component: UnitEditComponent
              }
            ]
          },
          {
            path: 'logs',
            component: LogsComponent
          },
          {
            path: 'user',
            children: [
              {
                path: '',
                component: UsersComponent
              },
              {
                path: ':id',
                component: UserEditComponent
              }
            ]
          },
          {
            path: 'device-type',
            children: [
              {
                path: '',
                component: DeviceTypeComponent
              },
              {
                path: ':id',
                component: DeviceTypeEditComponent
              }
            ]
          },
          {
            path: 'device-attribute',
            children: [
              {
                path: '',
                component: DeviceAttributeComponent
              },
              {
                path: ':id',
                component: DeviceAttributeEditComponent
              }
            ]
          },
          {
            path: 'yml',
            children: [
              {
                path: '',
                component: YmlListComponent
              },
              {
                path: ':id',
                component: YmlEditorComponent
              }
            ]
          },
          {
            path: 'influx',
            component: InfluxComponent
          }
        ]
      },
      {
        path: 'networks',
        canActivate: [AccessGuardService],
        children: [
          {
            path: '',
            component: NetworksComponent
          },
          {
            path: ':id',
            component: NetworkEditComponent

          }
        ]
      },
      {
        path: 'device',
        canActivate: [AccessGuardService],
        children: [
          {
            path: '',
            component: DeviceComponent
          },
          {
            path: ':id',
            component: DeviceViewComponent
          }
        ]
      },
      {
        path: 'attributelookup',
        canActivate: [AccessGuardService],
        component: AttributelookupComponent
      },
      {
        path: 'uploader',
        children: [
          {
            path: '',
            component: UploaderComponent
          }
        ]
      },
      {
        path: 'sync',
        canActivate: [AccessGuardService],
        component: SyncComponent
      },
      {
        path: 'sync15min',
        canActivate: [AccessGuardService],
        component: AxMpointSyncComponent
      }
    ],
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
